import { j as s } from "./jsx-runtime-Bdg6XQ1m.js";
import { a as m } from "./index-Djenk2Hj.js";
const e = ({
  children: t,
  className: r
}) => /* @__PURE__ */ s.jsx("div", { className: m("text-sm font-semibold text-primary mb-2", r), children: t });
export {
  e as C
};
//# sourceMappingURL=CategoryHeading-MYL1u_6K.js.map
